module.exports = __webpack_public_path__ + "static/img/NewsImage3.5cf4228.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/news/NewsImage3.png
// module id = T5pw
// module chunks = 1